import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiResponse } from '../schemas/common.schema';

const c = initContract();

export const LocationResponseSchema = z.object({
  _id: z.string(),
  location_name: z.string().optional(),
  location_type: z.number().optional(),
  location_area_id: z.number().optional(),
  location_path: z.string().optional(),
});

export const locationsContract = c.router({
  getLocations: {
    method: 'GET',
    path: '/locations',
    query: z.object({
      cursor: z.string().optional(),
      limit: z.coerce.number().optional(),
      locationType: z.coerce.number().optional(),
      countryIso: z.string().optional(),
      search: z.string().optional(),
    }),
    responses: { 200: apiResponse(z.array(LocationResponseSchema)) },
  },
});

export type LocationResponseDto = z.infer<typeof LocationResponseSchema>;
